// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"505":"8fbc4986","722":"aa4fb5f4"}[chunkId] + ".chunk.js";
};